import "core-js/stable";
import "react-app-polyfill/ie11";
import "./polyfills";
// Text encoding required for Edge and IE 11 to support Okta sign in widget.
import "fast-text-encoding";
// Webcrypto-shim required for IE11 to support Okta sign in widget.
import "webcrypto-shim";

import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore"; // eslint-disable-line import/default
import TagManager from "react-gtm-module";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import appConfig, { isNotProduction, getEnv } from "./config/appConfig";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

if (module.hot) {
  module.hot.accept();
}
const store = configureStore();
const tagManagerArgs = {
  gtmId: "GTM-KRJ9ZZW",
  dataLayer: {
    dataLayerReady: false
  }
};

TagManager.initialize(tagManagerArgs);

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: isNotProduction()
      ? "5f7f6419ceea680a52dd6a45" // DZ
      : "5f7f64198fd1c90b794d5969", // LIVE

    // To disable use of anonymous users which will hit user pool limits of LD,
    // we have opted to use partition as an identifier for flagging purposes until a user
    // is identified through login. This means that unauthenticated parts of code can be
    // flagged by targeting partition as user key.
    user: {
      key: appConfig.partition,
      anonymous: false
    },
    reactOptions: {
      useCamelCaseFlagKeys: false
    }
  });

  // Load the bridge bar
  const bridgeBar = document.createElement("script");
  bridgeBar.id = "bridge-bar-script";
  bridgeBar.async = false;
  bridgeBar.defer = false;
  bridgeBar.src = ["dangerzone", "local"].includes(getEnv())
    ? "https://assets.bridge.dangerzone.coxautoservices.com/bridge-bar.js"
    : "https://assets.bridge.coxautoservices.com/bridge-bar.js";
  document.body.appendChild(bridgeBar);

  render(
    <LDProvider>
      <Provider store={store}>
        <UnauthenticatedRoute />
      </Provider>
    </LDProvider>,
    document.getElementById("root")
  );

  // TODO: At one point we attempted to register a service worker, it hasn't been working for a while, so let's unregister them
  //  currently and then in the future let's remove this
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
})();
